import type { CSSProperties } from 'react';

type SafeAreaEdge = 'top' | 'right' | 'bottom' | 'left';

export function safeAreaInset(edge: SafeAreaEdge): string {
  return `env(safe-area-inset-${edge}, 0px)`;
}

export function withSafeArea(edge: SafeAreaEdge, px = 0): string {
  if (px === 0) return safeAreaInset(edge);
  return `calc(${safeAreaInset(edge)} + ${px}px)`;
}

export function safeAreaOffset(edge: SafeAreaEdge, px: number, minPx = px): string {
  return `max(${minPx}px, ${withSafeArea(edge, px)})`;
}

export function safeAreaPadding(
  topPx: number,
  rightPx: number,
  bottomPx: number,
  leftPx: number
): CSSProperties {
  return {
    paddingTop: withSafeArea('top', topPx),
    paddingRight: withSafeArea('right', rightPx),
    paddingBottom: withSafeArea('bottom', bottomPx),
    paddingLeft: withSafeArea('left', leftPx),
  };
}

export function safeAreaPaddingX(px: number): CSSProperties {
  return {
    paddingRight: withSafeArea('right', px),
    paddingLeft: withSafeArea('left', px),
  };
}
